export const getCurrencyFormat = (amount) => {
    var value = amount ?? 0;
    return Number(value).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
}